"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _drawer = _interopRequireDefault(require("./drawer"));

var _dropDown = _interopRequireDefault(require("./drop-down"));

var _scroll = _interopRequireDefault(require("./scroll"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class HeaderServices {
  /**
   * Class constructor
   * @param {HTMLElement} [headerEl] - The component element in the DOM
   */
  constructor(headerEl) {
    var drawer = new _drawer.default(headerEl);
    new _dropDown.default(headerEl, drawer);
    new _scroll.default(headerEl);
  }
  /**
   * Initialise header component
   * @param {(HTMLElement|String)} rootElement - The root element to intialise the component in, or a CSS selector for the root element
   * @param {Object} [options={}] - An options object for configuring the component
   */


  static init(rootEl, opts) {
    if (!rootEl) {
      rootEl = document.body;
    }

    if (!(rootEl instanceof HTMLElement)) {
      rootEl = document.querySelector(rootEl);
    }

    if (rootEl instanceof HTMLElement && rootEl.matches('[data-o-component=o-header-services]')) {
      return new HeaderServices(rootEl, opts);
    }

    return Array.from(rootEl.querySelectorAll('[data-o-component="o-header-services"]'), rootEl => new HeaderServices(rootEl, opts));
  }

}

var _default = HeaderServices;
exports.default = _default;
module.exports = exports.default;